export default "__VITE_ASSET__BG64ZvKM__"